/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-office-user-list',
  templateUrl: 'office-user-list.component.html',
  styleUrls: [],
})
export class OfficeUserListComponent {
}
